export default (id) => ({
  id,
  htmlId: null,

  init() {
    this.htmlId = this.$id("hubspot-form");
    this.$root.id = this.htmlId;

    const initForm = () => {
      hbspt.forms.create({
        region: "na1",
        portalId: 465429,
        formId: this.id,
        css: "",
        target: "#" + this.htmlId,
        onFormReady: ($form) => {
          document.querySelector('style[id^="hs-form-style"]').remove();
          this.$root.classList.remove("opacity-0");
        },
      });
    };

    if (window.hbspt) {
      initForm();
    } else {
      const maxAttempts = 100;
      let attempts = 0;
      const checkHubspot = setInterval(() => {
        attempts += 1;
        if (window.hbspt) {
          clearInterval(checkHubspot);
          initForm();
          return;
        }
        if (attempts >= maxAttempts) {
          clearInterval(checkHubspot);
        }
      }, 50);
    }
  },
});
